import { Environment } from '@ftr/window'

export const environment: Environment = {
  production: true,
  debugLogging: false,
}
